import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.open('https://tuebookonlineya.lat/cart/46410649075883:1', '_blank');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-terracotta text-white font-sans font-bold py-4 px-8 rounded-full shadow-lg hover:bg-opacity-90 transition-colors duration-300 ${className}`} {...props} data-id="element-13">
      {children}
    </motion.button>;
}